var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIncomingCallSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 4
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.659 2.889V.222H0V4h3.736v-.667H1.143L4 .489 3.516 0z",
    fill: "#2ad465"
  })));
}

export default SvgIncomingCallSm;